import { css } from '@emotion/react';
import { WeaveLogo } from '@frontend/assets';
import { useTranslation } from '@frontend/i18n';
import { titleCase } from '@frontend/string';
import { theme } from '@frontend/theme';
import { Heading } from '@frontend/design-system';
import { useDentalInsuranceReportContext } from '../../context/DentalInsuranceReportDetailsContext.provider';

export const PrintableHeader = () => {
  const { t } = useTranslation('insuranceEligibilityReport');
  const {
    insuranceEligibilityReportData: { dentalSummaryInfo: { patient } = {} },
  } = useDentalInsuranceReportContext();

  const reportFirstName = patient?.firstName ? `${titleCase(patient.firstName)}'s` : '';

  if (!reportFirstName) return null;

  return (
    <section css={printableHeaderStyles}>
      <div css={{ display: 'flex', gap: theme.spacing(2), alignItems: 'baseline' }}>
        <Heading>{reportFirstName}</Heading>
        <Heading level={3}>{t('Insurance Verification Report')}</Heading>
      </div>
      <WeaveLogo />
    </section>
  );
};

const printableHeaderStyles = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  padding: theme.spacing(2, 3),
});
